import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { OfferScope } from '../../types';
import { TalentPoolsBriefActions } from './talent-pools-brief.store';
import { TalentPoolsHttpService } from './talent-pools-http.service';

@Injectable({
  providedIn: 'root',
})
export class TalentPoolsBriefEffects {
  public effects = createEffectFactory(TalentPoolsBriefActions, this.actions$);

  public fetchActiveCollection$ = this.effects(TalentPoolsBriefActions.fetchActiveCollection, () =>
    of(
      TalentPoolsBriefActions.fetchCollection({
        payload: { scope: OfferScope.Active },
      }),
    ),
  );

  public fetchArchivedCollection$ = this.effects(
    TalentPoolsBriefActions.fetchArchivedCollection,
    () =>
      of(
        TalentPoolsBriefActions.fetchCollection({
          payload: { scope: OfferScope.Archived },
        }),
      ),
  );

  public fetchCollection$ = this.effects(
    TalentPoolsBriefActions.fetchCollection,
    ({ payload }) =>
      this.talentPoolsHttpService.fetchBriefCollection$(payload?.scope).pipe(
        map(response => ({
          data: response.offers,
          scope: payload?.scope,
        })),
      ),
    {
      customMapOperator: mergeMap,
    },
  );

  constructor(
    private talentPoolsHttpService: TalentPoolsHttpService,
    private actions$: Actions,
  ) {}
}
